import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_RatePlans } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CreateForm from './CreateForm';
import Validation from '../../../../../../../components/Validation';
function CreateRatePlansForm({ propertyId }) {
  const [isCreating, setIsCreating] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);

  const handleSubmit = data => {
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_RatePlans}/${propertyId}`,
      data,
    })
      .then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  return (
    <div>
      <Button
        color="primary"
        outline
        size="xs"
        onClick={() => {
          setIsCreating(!isCreating);
        }}
        style={{ width: '100%', borderRadius: '6px' }}
      >
        + Create a New Rate Plan
      </Button>
      <CreateForm
        formLabel="Create a New Rate Plan"
        visible={isCreating}
        toggle={() => {
          setIsCreating(!isCreating);
        }}
        submit={handleSubmit}
      />
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreateRatePlansForm));

CreateRatePlansForm.propTypes = {
  propertyId: PropTypes.string.isRequired,
};
